module.exports = __webpack_public_path__ + "static/media/emil_avatar.de40f9b8.jpg";